@if (ccDepositLimitCheckEnabled && showCCDepositLimitCheckMsg) {
    <show-message id="creditcard_deposit_limit_message2" [type]="messageType.ERROR">
        <div error>
            <p>
                {{
                    'PARTY.CASHIER.web.deposit.ny.creditcard.deposit.limit.message2'
                        | translate
                            : {
                                  annualLimit: ccDepositUcapLimit | vnCurrency: currencyUSD,
                                  avlAmount: ccCurrentDepositLimit | vnCurrency: currencyUSD,
                              }
                }}
            </p>
            <p>
                <b
                    ><a (click)="updateCcdLimit()" id="updateccdlimit">{{
                        'PARTY.CASHIER.web.deposit.ny.creditcard.deposit.limits.update' | translate
                    }}</a></b
                >
            </p>
        </div>
    </show-message>
}
@if (selfLimits?.type?.includes('purchase_limit')) {
    @if (maxDepositLimit > '0') {
        <show-message [type]="messageType.ERROR">
            <div error>
                <span>
                    <p
                        [vnDynamicHtml]="
                            'PARTY.CASHIER.web.limits.purchaselimits.exceeded1.msg1'
                                | translate: { frequency: limitPeriod, instrument: instrumentName }
                        "></p>
                    @if (minDepositLimitCheck) {
                        <p>
                            {{
                                'PARTY.CASHIER.web.limits.exceeded2'
                                    | translate
                                        : {
                                              remainingLimit:
                                                  maxDepositLimit | vnCurrency: selectedOption?.paymentMethodInfo?.maxDepositLimit?.currencyCode,
                                          }
                            }}
                        </p>
                        <a class="fr" (click)="changeAmount()" id="updateAmount">{{ 'PARTY.CASHIER.web.limits.exceeded3' | translate }}</a>
                    }
                </span>
            </div>
        </show-message>
    }
    @if (maxDepositLimit == '0') {
        <show-message [type]="messageType.ERROR">
            <div error>
                <p
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.limits.purchaselimits.exceeded1.msg2' | translate: { frequency: limitPeriod, instrument: instrumentName }
                    "></p>
            </div>
        </show-message>
    }
}
